import { RealtimeClient } from "../RealtimeClient";
import { RestClient } from "../restClient";

export class WorkstationInfo {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	getLogoutDisabled(wsid, callback) {
		const url = `/ecosystem/api/workstations/${wsid}/logoutDisabled`;
		this._restClient.exec_get(url, callback);
	}
}
